import type { ReceiptTemplate } from '../schema';

export const saksFifthAvenueTemplate: ReceiptTemplate = {
  id: 'saks-fifth-avenue',
  name: 'Saks Fifth Avenue Receipt',
  brand: 'SAKS FIFTH AVENUE',
  description: 'Saks Fifth Avenue luxury department store receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'saks-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/saks-fifth-avenue.png',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: '',
        businessNameFontSize: 14,
        addressLines: [
          '611 FIFTH AVENUE',
          'NEW YORK, NY 10022',
          '(212) 555-0127',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'saks-trans',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'store', label: 'Store:', value: '001' },
          { id: 'trans', label: 'Trans:', value: '847291' },
        ],
        column2: [
          { id: 'date', label: 'Date:', value: '01/04/2026' },
          { id: 'assoc', label: 'SA:', value: 'MIKE W.' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'saks-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        items: [
          { id: '1', name: 'VALENTINO ROCKSTUD', quantity: '1', price: '1095.00', sku: '0400847291' },
          { id: '2', name: 'LA MER MOISTURIZER', quantity: '1', price: '380.00', sku: '0400847292' },
        ],
        showQuantity: true,
        showSku: true,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'saks-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'subtotal', label: 'SUBTOTAL', value: '1475.00', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX', value: '130.91', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '1605.91', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'saks-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        method: 'SAKS CARD ****4144',
        fields: [
          { id: 'auth', label: 'Auth:', value: '059746' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'saks-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'SAKSF1RST MEMBER\n\nReturns within 30 days\nwith receipt\n\nTHANK YOU',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
  updatedAt: new Date().toISOString(),
};

